import { type CopyRule, withoutFileHostingSources } from "./file-hosting-sources";

// Scriptario copy: only Zoom and Google Drive were added.
export const INTL_FILE_HOSTING_RULES: readonly CopyRule[] = [
  // en
  ["Paste a YouTube, Zoom or Google Drive link...", "Paste a YouTube link..."],
  ["Or paste a YouTube, Zoom or Google Drive link.", "Or paste a YouTube link."],
  ["Paste a YouTube, Zoom recording or Google Drive link and", "Paste a YouTube link and"],
  ["YouTube videos, Zoom recordings and Google Drive files are supported through links,", "YouTube video transcription is supported through links,"],
  ["a public YouTube, Zoom or Google Drive link.", "a public YouTube link."],
  ["already on YouTube, Zoom or Google Drive, paste", "already on YouTube, paste"],
  // de
  ["YouTube-, Zoom- oder Google-Drive-Link einfügen...", "YouTube-Link einfügen..."],
  ["oder fügen Sie einen YouTube-, Zoom- oder Google-Drive-Link ein.", "oder fügen Sie einen YouTube-Link ein."],
  ["einen YouTube-, Zoom-Aufnahme- oder Google-Drive-Link ein.", "einen YouTube-Link ein."],
  ["einen öffentlichen Link zu YouTube, Zoom oder Google Drive einfügen.", "einen öffentlichen YouTube-Link einfügen."],
  ["bereits auf YouTube, Zoom oder Google Drive, können", "bereits auf YouTube, können"],
  // es
  ["Pega un enlace de YouTube, Zoom o Google Drive...", "Pega un enlace de YouTube..."],
  ["pegar un enlace de YouTube, Zoom o Google Drive.", "pegar un enlace de YouTube."],
  ["Pega un enlace de YouTube, de una grabación de Zoom o de Google Drive y", "Pega un enlace de YouTube y"],
  ["un enlace público de YouTube, Zoom o Google Drive.", "un enlace público de YouTube."],
  ["ya está en YouTube, Zoom o Google Drive, pega", "ya está en YouTube, pega"],
  // pt-br
  ["Cole um link do YouTube, Zoom ou Google Drive...", "Cole um link do YouTube..."],
  ["Ou cole um link do YouTube, Zoom ou Google Drive.", "Ou cole um link do YouTube."],
  ["Cole um link do YouTube, de uma gravação do Zoom ou do Google Drive e", "Cole um link do YouTube e"],
  ["um link público do YouTube, Zoom ou Google Drive.", "um link público do YouTube."],
  ["já estiver no YouTube, Zoom ou Google Drive, cole", "já estiver no YouTube, cole"],
  // it
  ["Incolla un link YouTube, Zoom o Google Drive...", "Incolla un link YouTube..."],
  ["Oppure incolla un link YouTube, Zoom o Google Drive.", "Oppure incolla un link YouTube."],
  ["Incolla un link YouTube, di una registrazione Zoom o di Google Drive e", "Incolla un link YouTube e"],
  ["un link pubblico di YouTube, Zoom o Google Drive.", "un link pubblico di YouTube."],
  ["è già su YouTube, Zoom o Google Drive, incolla", "è già su YouTube, incolla"],
];

export function intlFileHostingCopy<T>(value: T, enabled?: boolean): T {
  return withoutFileHostingSources(value, INTL_FILE_HOSTING_RULES, enabled);
}
